import { render, staticRenderFns } from "./publication-old.vue?vue&type=template&id=77b4f3c4&scoped=true&"
import script from "./publication-old.vue?vue&type=script&lang=js&"
export * from "./publication-old.vue?vue&type=script&lang=js&"
import style0 from "./publication-old.vue?vue&type=style&index=0&id=77b4f3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b4f3c4",
  null
  
)

export default component.exports